(function ($) {
    $.fn.displaydate = function () {
        return this.each(function () {

            let dateMin = $(this).data('displaydate-min');
            if (dateMin) {
                dateMin = dateMin.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1-$2-$3 00:00:00');
                dateMin = new Date(dateMin);
            }

            let dateMax = $(this).data('displaydate-max');
            if (dateMax) {
                dateMax = dateMax.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1-$2-$3 23:59:59');
                dateMax = new Date(dateMax);
            }

            let dateNow = new Date();
            if ((dateMax != null && dateMax <= dateNow) || (dateMin != null && dateMin >= dateNow)) {
                $(this).hide();
            }

        });

    };

}(jQuery));